import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { format } from "date-fns";

type ChatMessageBubbleProps = {
  message: {
    id: string;
    content: string;
    timestamp: Date;
    senderId: string;
    senderName?: string;
    senderAvatar?: string;
  };
  isCurrentUser: boolean;
  recipientName?: string;
  showSenderName?: boolean;
};

export default function ChatMessageBubble({
  message,
  isCurrentUser,
  recipientName,
  showSenderName = false,
}: ChatMessageBubbleProps) {
  const timestamp =
    typeof message.timestamp === "string"
      ? new Date(message.timestamp)
      : message.timestamp;

  return (
    <div className={`flex ${isCurrentUser ? "justify-end" : "justify-start"}`}>
      <div className="flex max-w-[80%] group">
        {!isCurrentUser && (
          <Avatar className="h-8 w-8 mr-2 mt-1 flex-shrink-0">
            <AvatarImage src={message.senderAvatar} />
            <AvatarFallback>
              {message.senderName?.slice(0, 2).toUpperCase() ||
                recipientName?.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        )}

        <div>
          {showSenderName && !isCurrentUser && (
            <p className="text-xs font-medium text-muted-foreground mb-1">
              {message.senderName}
            </p>
          )}

          <div
            className={`rounded-xl px-4 py-2 ${
              isCurrentUser ? "bg-primary text-primary-foreground" : "bg-muted"
            } break-words`}
          >
            <p className="text-sm">{message.content}</p>
          </div>
          <p className="text-xs text-muted-foreground mt-1 opacity-70 group-hover:opacity-100">
            {format(timestamp, "h:mm a")}
          </p>
        </div>
      </div>
    </div>
  );
}
